import React from "react";
import "./MusicPlayer.css";
import { useState, useEffect } from "react";
import LogoVersiculo from "../VersiculoAlbum/VersiculoAlbum";
import { Dialog, DialogTitle, DialogContent, DialogActions, Chip } from "@mui/material";
import {
  Modal,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  IconButton,
  Slider,
  Box,
  Button,
  Stack,
} from "@mui/material";
import {
    ErrorRounded,
    PlayArrowRounded,
    IosShareOutlined,
    StopRounded,
    VolumeUpRounded,
    VolumeDownRounded,
    VolumeOffRounded,
} from "@mui/icons-material";

const MusicPlayer = ({isPlaying, volume, handlePlay, handleVolumeChange, isLoading, navigate}) => {
    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState({
      title: 'Error al cargar',
      message: 'Verifica tu conexion a internet, si el problema persiste contacta a soporte',
    });
    const [openModal, setOpenModal] = useState(false);
    const [showVolumeSlider, setShowVolumeSlider] = useState(false);

    const toggleVolumeSlider = () => {
      setShowVolumeSlider(!showVolumeSlider);
    };

    const ModalComponent = () => {
      return (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              p: 2,
              width: '80%',
            }}
          >
            {/*icon*/}
            <ErrorRounded color="error" sx={{ fontSize: 40 }} />
            <h2>{modal.title}</h2>
            <p>{modal.message}</p>
            {/* Cerrar */}
            <Button onClick={() => setOpenModal(false)}>Cerrar</Button>
          </Box>
        </Modal>
      );
    };

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
          setOpen(false);
        }
    };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between", // Distribuye los elementos a lo largo del alto
        alignItems: "center",
        height: "95vh", // Ocupa todo el alto de la pantalla
        // bgcolor: "background.default",
      }}
    >
      {/* Header */}
      {/* <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar sx={{ justifyContent: "space-between", color: "white" }}>
          <IconButton edge="start" onClick={toggleDrawer(true)} sx={{ color: "white" }}>
            <Menu />
          </IconButton>
          <Typography variant="h6" component="div">
            Embajadores Stereo
          </Typography>
          <IconButton edge="end">
            <CastConnected />
          </IconButton>
        </Toolbar>
      </AppBar> */}

      <Chip label="Versiculo del día" color="primary" onClick={() => navigate("/versiculodeldia")} />

      {/* Album Cover and Info */}
      <LogoVersiculo />

    

      {/* Controls */}
      <Box sx={{ width: "90%", maxWidth: 400 }}>
        {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="body2">17:05</Typography>
          <Typography variant="body2">-11:41</Typography>
        </Box>
        <Slider
          defaultValue={50}
          aria-label="Progress"
          sx={{
            color: "primary.main",
          }}
        /> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            mt: 1,
          }}
        >
          {/* <IconButton
                onClick={toggleCasting}
                variant={isCasting ? "contained" : "outlined"}
                color={isCasting ? "primary" : "inherit"}
                disabled={!castInitialized}
          >
            {isCasting ? <CastConnected /> : <CastOutlined />}
          </IconButton> */}
          <IconButton onClick={toggleVolumeSlider}>
            { volume === 0 ? <VolumeOffRounded /> : volume < 50 ? <VolumeDownRounded /> : <VolumeUpRounded /> }
          </IconButton>
          <IconButton
            sx={{
              bgcolor: "primary.main",
              color: "white",
              "&:hover": {
                bgcolor: "primary.dark",
              },
              height: 100,
              width: 100,
            }}
            onClick={handlePlay}
            loading={isLoading}
            disabled={isLoading}
          >
            {isPlaying ? (
                <StopRounded
                    sx={{
                        fontSize: 40,
                    }}
                />
            ) : (
                <PlayArrowRounded
                    sx={{
                        fontSize: 40,
                    }}
                />
            )}
            
          </IconButton>
          <IconButton onClick={() => {
              if (navigator.share) {
                  navigator.share({
                      title: 'Embajadores Stereo',
                      text: 'Estoy escuchando Embajadores Stereo',
                      url: 'https://radio.embajadoresdelgranrey.com',
                  }).catch(console.error);
              } else {
                  navigator.clipboard.writeText("Escucha Embajadores Stereo: https://radio.embajadoresdelgranrey.com");
                  alert("Texto copiado al portapapeles");
              }
          }}>
              <IosShareOutlined />
          </IconButton>
        </Box>
        {showVolumeSlider ? (
          <Stack
            spacing={2}
            direction="row"
            sx={(theme) => ({
              my: 4,
              px: 1,
              '& > svg': {
                color: 'rgba(0,0,0,0.4)',
                ...theme.applyStyles('dark', {
                  color: 'rgba(255,255,255,0.4)',
                }),
              },
            })}
            alignItems="center"
          >
            <VolumeDownRounded />
            <Slider
              aria-label="Volume"
              value={volume}
              onChange={handleVolumeChange}
              sx={(t) => ({
                color: '#3555dd',
                '& .MuiSlider-track': {
                  border: 'none',
                },
                '& .MuiSlider-thumb': {
                  width: 24,
                  height: 24,
                  backgroundColor: '#fff',
                  '&::before': {
                    boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
                  },
                  '&:hover, &.Mui-focusVisible, &.Mui-active': {
                    boxShadow: 'none',
                  },
                },
                ...t.applyStyles('dark', {
                  color: '#fff',
                }),
              })}
            />
            <VolumeUpRounded />
          </Stack>
        ) : (
          <Box sx={{ height: 20 }} />
        )}

        {/* <Button
            variant="outlined"
        //   startIcon={<Lyrics />}
          fullWidth
          sx={{ mt: 2, textTransform: "none" }}
          onClick={handleOpenPrograms}
        >
          Programación
        </Button> */}

        {/* espacio */}
        <Box sx={{ height: 20 }} />

      </Box>

      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle>Nuestra programación</DialogTitle>
        <DialogContent>
            {/* tabla de programación */}
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Hora</TableCell>
                            <TableCell>Programa</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>7:00 AM</TableCell>
                            <TableCell>Un momento con Dios</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>9:00 AM</TableCell>
                            <TableCell>Un momento con Dios</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>11:00 AM</TableCell>
                            <TableCell>Un momento con Dios</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>05:00 PM</TableCell>
                            <TableCell>Un momento con Dios</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>6:00 PM</TableCell>
                            <TableCell>Edificados por la palabra</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      <ModalComponent />

    </Box>
  );
};

export default MusicPlayer;
